import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { LayoutStack } from '../layouts';
import styles from './Tile.module.css';
import { TileCompanionProps, TileProps } from './types';
function Tile({
  id,
  className,
  children,
  border = 'neutral',
  inert
}: TileProps) {
  return <LayoutStack id={id} space="none" className={classNames([styles.container, {
    [styles.neutralBorderContainer!]: border === 'neutral',
    [styles.transparentBorderContainer!]: border === 'transparent'
  }, className ?? ''])} inert={inert}>
      {children}
    </LayoutStack>;
}
function Header(t0) {
  const $ = _c(10);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = classNames(className, styles.headerContainer);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== props || $[8] !== t1) {
    t2 = <div className={t1} {...props}>{children}</div>;
    $[6] = children;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}
function Content(t0) {
  const $ = _c(10);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = classNames(className, styles.contentContainer);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== props || $[8] !== t1) {
    t2 = <div className={t1} {...props}>{children}</div>;
    $[6] = children;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}
Tile.Header = Header;
Tile.Content = Content;
export default Tile;